type TickerSubscriptionBot = {
  symbol?: string
  setData?: {
    symbol?: string
  } | null
}

export const normalizeTickerSubscriptionSymbols = (
  symbols: Iterable<string | undefined | null>,
) => {
  const unique = new Set<string>()

  for (const symbol of symbols) {
    const next = symbol?.trim()
    if (!next) continue
    unique.add(next)
  }

  return Array.from(unique).sort()
}

export const getTickerSubscriptionSymbols = (
  favoriteSymbols: Iterable<string>,
  bots: TickerSubscriptionBot[],
  extraSymbols: Iterable<string | undefined | null> = [],
) => {
  const botSymbols = bots.flatMap(bot => [bot.symbol, bot.setData?.symbol])
  return normalizeTickerSubscriptionSymbols([...favoriteSymbols, ...botSymbols, ...extraSymbols])
}
